import produce from "immer"
import { CcLibraryHeading } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initCcLibraryHeading: CcLibraryHeading = {
    id: null,
    headingId: null,
    librarySetId: null,
    title: "",
    order: 0,
}

const initCcLibraryHeadingState: types.CcLibraryHeadingState = {
    headingList: {},
    headingEdit: initCcLibraryHeading,
    reloadEdit: true,

    availableParents: [],
    availableParentsFiltered: [],
    availableParentSearch: "",

    menuTargetId: null,
    menuTargetElement: null,

    confirmDelete: null,
}

const ccLibraryHeadingReducer = produce((
    draft: types.CcLibraryHeadingState = initCcLibraryHeadingState,
    action: ActionTypes = null,
): types.CcLibraryHeadingState => {
    switch (action.type) {
        case types.CC_LIBRARY_HEADING_LIST:
            draft.headingList = action.headingList
            return draft

        case types.CC_LIBRARY_HEADING_EDIT:
            draft.headingEdit = action.heading
            return draft

        case types.CC_LIBRARY_HEADING_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        case types.CC_LIBRARY_HEADING_AVAILABLE_PARENTS:
            draft.availableParents = action.parents
            return draft

        case types.CC_LIBRARY_HEADING_AVAILABLE_PARENTS_FILTERED:
            draft.availableParentsFiltered = action.parentsFiltered
            return draft

        case types.CC_LIBRARY_HEADING_AVAILABLE_PARENT_SEARCH:
            draft.availableParentSearch = action.search
            return draft

        case types.CC_LIBRARY_HEADING_MENU:
            draft.menuTargetId = action.targetId
            draft.menuTargetElement = action.targetElement
            return draft

        case types.CC_LIBRARY_HEADING_CONFIRM_DELETE:
            draft.confirmDelete = action.heading
            return draft

        default:
            return draft
    }
})
export default ccLibraryHeadingReducer
